import { makeStyles } from '@material-ui/core/styles'

import { COLORS, FONT_FAMILY, FONT_WEIGHT } from 'styles'

const useStyles = makeStyles({
  pageCard: {
    backgroundColor: COLORS.WHITE,
    overflow: 'hidden',
  },
  pageTitle: {
    padding: '16px 24px 8px',
    fontFamily: FONT_FAMILY,
    fontWeight: FONT_WEIGHT.semiBold,
    fontSize: 20,
    color: COLORS.PRIMARY,
  },
  tabs: {
    padding: '0 16px',
    borderBottom: `1px solid ${COLORS.LIGHT_GREY}`,
  },
  pageBody: {
    padding: '8px 24px 16px',
  },
  editorSection: {
    marginBottom: 32,
  },
  pageActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '12px 24px 16px',
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    padding: 32,
  },
})

export { useStyles }
